import { System } from 'ngx-core-services';

export const checkForChangesInSystems = (oldSystems?: System[] | null, newSystems?: System[] | null): boolean => {
  const oldUids = new Set(oldSystems?.map((system) => system.uid));
  const newUids = new Set(newSystems?.map((system) => system.uid));

  if (oldUids.size !== newUids.size) {
    return true;
  }

  /**
   * Check if there are any new uids
   */
  for (const uid of newUids) {
    if (!oldUids.has(uid)) {
      return true;
    }
  }

  return false;
};
